import React from 'react';
import Address from './Address';

function AddressBookList({
  addressBookData = [],
  type,
  selectAny,
  handleAddressSelect,
  editPopup,
  setEditPopup,
  onDelete,
}) {
  return (
    <>
      {/* addressBodyLeft */}
      <div id="addressbookListBlock" className="">
        {/* <div
          className="bodyLeftAdd"
          onClick={() => setEditPopup({ open: true, referringMasterId: '' })}
        >
          <h3 className="cursor">
            {type === 2 && '+ Add New Provider'}
            {type === 3 && '+ Add New Facility'}
            {type === 4 && '+ Add New Insurance'}
            {type === 5 && '+ Add New Recipient'}
          </h3>
        </div> */}
        <div
          className="bodyLeftAddq addressFacility border border-dashed border-lightgray rounded-sm"
          onClick={() => setEditPopup({ open: true, referringMasterId: '' })}
        >
          <p className="cursor accent-forground fs-14 flex items-center gap-2 px-3 py-2-5">
            {type === 2 && '+ Add New Provider'}
            {type === 3 && '+ Add New Facility'}
            {type === 4 && '+ Add New Insurance'}
            {type === 5 && '+ Add New Recipient'}
          </p>
        </div>
        {/* bodyLeftContainer */}
        <div className="scrollbar-sm mt-2">
          {addressBookData.length > 0 &&
            addressBookData.map((val) => (
              <Address
                key={val.id}
                data={val}
                handleAddressSelect={handleAddressSelect}
                editPopup={editPopup}
                setEditPopup={setEditPopup}
                onDelete={onDelete}
                type={type}
              />
            ))}
        </div>
      </div>
    </>
  );
}
export default AddressBookList;
